import { useState } from 'react';
import { MP_WEBAPP_RESOURCE_PARAM } from '../utils/constants';

export const useUnits = (unitSteps) => {
	const [units, setUnits] = useState(() => {
		// Check if the URL contains a resource count parameter and set the units accordingly
		const locationSearchParams = new URLSearchParams(window.location.search);
		if (locationSearchParams.has(MP_WEBAPP_RESOURCE_PARAM)) {
			const resources = parseInt(locationSearchParams.get(MP_WEBAPP_RESOURCE_PARAM));
			if (resources) {
				// Find the unit step that is greater or equal to the resources
				const unitStep = unitSteps.find((unitStep) => unitStep.units >= resources);
				if (unitStep) {
					return unitStep.units;
				}
			}
		}

		// Set the default units
		return unitSteps[0].units;
	});

	return [units, setUnits];
};
